/**
 * Legacy 后端服务根地址配置。
 * OKR 旧模块（用户、项目、事件等）仍依赖这些域名；全效新接口走 coreapi.js 的 /core-api 网关。
 */
function legacyBase() {
    if (typeof window !== 'undefined' && /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)) {
        return 'http://127.0.0.1:8095/legacy-api/BRKJ/Base'
    }
    return 'https://user.hao-xiansheng.com/BRKJ/Base'
}

const legacyBaseUrl = legacyBase()

export default {
    // 本地
    // baseapi: 'http://192.168.4.230:5013/BRKJ/Promotion/PS',

    // 正式服；本机页面改走 8095 上的本地登录
    baseapi: legacyBaseUrl + '/IUserWork',
    baseProject: 'https://user.hao-xiansheng.com/BRKJ/Base/IProjectWork',
    baseEvent: 'https://user.hao-xiansheng.com/BRKJ/Base/IEventWork',
    basePic: 'https://welike.hao-xiansheng.com/Manage/UploadFile',
    baseUnit: legacyBaseUrl + '/IUserWork',

    // 测试服
    // baseapi: 'http://192.168.4.11:7077/BRKJ/Base/IUserWork',
    // baseProject: 'http://192.168.4.11:7077/BRKJ/Base/IProjectWork',
    // baseEvent: 'http://192.168.4.11:7077/BRKJ/Base/IEventWork',
}



// WEBPACK FOOTER //
// ./src/utils/base.js